export default __webpack_public_path__ + "static/media/1502.9d791df1.png";